module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dynamicDataSets/components/dynamic-dataset-tile.component.scss
// module id = ./src/app/dynamicDataSets/components/dynamic-dataset-tile.component.scss
// module chunks = main